import type { Variant } from '@core/Entities/Vehicle/Variant.entity';
import type { VehicleSpec } from '@core/Entities/Vehicle/VehicleSpec.entity';
import { Typography } from '@gds/Typography/Typography';

import styles from './VehicleAttributes.module.css';

type VehicleNameProps = {
  name: string;
  variant?: Variant;
  spec: VehicleSpec;
  isScrolling?: boolean;
};

export const VehicleName = ({ name, variant, spec, isScrolling }: VehicleNameProps) => {
  return (
    <div className={styles.makeModelNameWrapper}>
      <Typography
        variant={isScrolling ? 'h6' : 'h4'}
        className={styles.vehiclePrettyName}
        dataTestId="vehiclePrettyName"
      >
        {name}
      </Typography>
      <Typography className={styles.vehicleVariantName} dataTestId="vehicleVariantName">
        {variant?.label || spec.display}
      </Typography>
    </div>
  );
};
